import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  showProductDetail: {
    id: 'reviewsPage.showProductDetailButton',
    defaultMessage: 'Zobrazit detail',
  },
  reviewsPageTitle: {
    id: 'reviewsPage.title',
    defaultMessage: 'Recenze {productFullName}',
  },
  rcButton: {
    id: 'reviewsPage.stickyHeader.richContentButton.text',
    defaultMessage: 'Recenze z redakce',
  },
  yourReviewsButton: {
    id: 'reviewsPage.stickyHeader.yourReviewsButton.text',
    defaultMessage: 'Vaše recenze',
  },
});
